import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButton from '../../../Elements/FigmaButton';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import React from 'react';
import CommissionRateSearchParams from './CommissionRateSearchParams';
import CommissionRateService from '../../../Services/CommissionRateService';
import CommissionRateOverrideItem from '../../../Domain/CommissionRateOverrideItem';

export default class ChooseCommissionPanel extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {},
    clickOnSubmit: () => {},
    searchItem: new CommissionRateSearchParams(),
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      selected: {},
      saving: false,
      searchItem: props.searchItem,
    };

    CommissionRateOverrideItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.CommissionRateId === item.CommissionRateId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
      selected: { ...item },
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });
    this.props.clickOnSubmit(this.state.selected);
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Override Commission'
          icon={`fa-solid fa-copy${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={() => this.handleOnSubmit()}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        title={'Choose Commission To Be Used'}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.clickOnCancel(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        zIndex={1050}
        className='applySurveyPanel top-of-boxFigma'
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>
          <TabOfDataTable
            itemList={this.state.itemList}
            type={CommissionRateOverrideItem}
            serviceFunction={CommissionRateService.GetListBySearching}
            changeOfItemListFunction={(itemList) => this.setState({ itemList })}
            convertDBItemsFunction={CommissionRateService.ConvertOverrideDBItems}
            showSearchStrip={false}
            enableUrlPush={false}
            searchParamsType={CommissionRateSearchParams}
            clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
            searchItem={this.state.searchItem}
          />
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
